// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__q4YQy","footer":"ModalCreateQualiphyProcedure_footer__34Dhr","additionData":"ModalCreateQualiphyProcedure_additionData__2Oa1w"};